import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import '../styles/Regalos.css';
import '../styles/Extras.css';

const TIPOS = {
  likes_masivos: '🤖 Posible bot',
  mensaje_repetido: '📢 Mensaje repetido a muchos',
  pide_dinero: '💸 Pide dinero o datos bancarios',
  fuerza_bruta: '🔐 Muchas contraseñas incorrectas',
  foto_inapropiada: '🔞 Foto inapropiada (cuenta bloqueada)',
  foto_sin_revisar: '🕵️ Foto que la IA no pudo revisar',
};
const fecha = (s) => new Date(String(s).replace(' ', 'T') + 'Z').toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' });

// Alertas automáticas de comportamiento sospechoso. No bloquean a nadie: el admin decide.
export default function AlertasAdmin({ success, error }) {
  const [estado, setEstado] = useState('pendiente');
  const [alertas, setAlertas] = useState(null);

  const load = useCallback(async () => {
    try { const d = await api.adminAlertas(estado); setAlertas(d.alertas || []); }
    catch (e) { setAlertas([]); error(e.message || 'Error cargando alertas.'); }
  }, [estado, error]);
  useEffect(() => { load(); }, [load]);

  const revisar = async (id) => {
    try { await api.adminRevisarAlerta(id); success('Alerta marcada como revisada.'); load(); }
    catch (e) { error(e.message); }
  };
  const revisarFoto = async (a, accion) => {
    const textos = { aprobar: '¿La foto está bien? Vuelve al perfil y se reactiva la cuenta.', borrar_reactivar: '¿Borrar la foto y reactivar la cuenta?', borrar_suspender: '¿Borrar la foto y dejar la cuenta suspendida?' };
    if (!window.confirm(textos[accion])) return;
    try { await api.adminRevisarFoto(a.foto_revision_id, accion); success('Listo, le avisamos al usuario por correo.'); load(); }
    catch (e) { error(e.message); }
  };
  const banear = async (a) => {
    if (!window.confirm(`¿Suspender a ${a.name}?`)) return;
    try { await api.adminSetStatus(a.user_id, 'banned', `Alerta: ${TIPOS[a.tipo] || a.tipo}`); await api.adminRevisarAlerta(a.id); success('Usuario suspendido.'); load(); }
    catch (e) { error(e.message); }
  };

  return (
    <div>
      <p className="regalo-note" style={{ marginBottom: 12 }}>
        El sistema marca cuentas con comportamiento raro. Solo las fotos con desnudos o contenido sexual bloquean la cuenta al instante; el resto lo decidís vos.
      </p>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button className={`btn btn-sm ${estado === 'pendiente' ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setEstado('pendiente')}>Pendientes</button>
        <button className={`btn btn-sm ${estado === 'revisada' ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setEstado('revisada')}>Revisadas</button>
      </div>
      {alertas === null ? <p className="regalos-empty">Cargando…</p>
        : alertas.length === 0 ? <p className="regalos-empty">No hay alertas {estado === 'pendiente' ? 'pendientes' : 'revisadas'}. 🎉</p>
        : alertas.map(a => (
          <div key={a.id} className="comercio-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
              <div style={{ minWidth: 0 }}>
                <strong>{TIPOS[a.tipo] || a.tipo}</strong> · {a.name} <span style={{ color: 'var(--texto-muted)' }}>({a.email})</span>
                {a.status === 'banned' && <span style={{ color: 'var(--rojo-claro)' }}> · suspendido</span>}
                <div style={{ fontSize: 13, color: 'var(--texto-suave)', marginTop: 4, wordBreak: 'break-word' }}>{a.detalle}</div>
                <div style={{ fontSize: 12, color: 'var(--texto-muted)', marginTop: 2 }}>{fecha(a.created_at)}</div>
                {a.foto_revision_id && (
                  <img src={`/api/admin/fotos-revision/${a.foto_revision_id}/imagen`} alt="Foto en revisión (tocala para verla)" className="foto-revision" tabIndex={0} />
                )}
              </div>
              {estado === 'pendiente' && a.foto_revision_id ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'stretch' }}>
                  <button className="btn btn-outline btn-sm" onClick={() => revisarFoto(a, 'aprobar')}>Foto OK, reactivar</button>
                  <button className="btn btn-outline btn-sm" onClick={() => revisarFoto(a, 'borrar_reactivar')}>Borrar foto y reactivar</button>
                  <button className="btn btn-sm btn-primary" onClick={() => revisarFoto(a, 'borrar_suspender')}>Borrar foto y suspender</button>
                </div>
              ) : estado === 'pendiente' && (
                <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                  <button className="btn btn-outline btn-sm" onClick={() => revisar(a.id)}>Todo bien</button>
                  {a.status !== 'banned' && <button className="btn btn-sm btn-primary" onClick={() => banear(a)}>Suspender</button>}
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}
